import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { Observable, from, throwError } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { FirebaseAuthService } from './firebase-auth.service';
export const InterceptorSkipHeader = 'X-Skip-Interceptor';

@Injectable({
	providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
	  constructor(private firebaseAuthService: FirebaseAuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.firebaseAuthService.isAuthenticated().pipe(
      mergeMap(isAuthenticate => {
        if (isAuthenticate) {
          return this.firebaseAuthService.getJwt().pipe(
            mergeMap(jwt => {
              return this.setJwtOrSkip(request, next, jwt);
            }),
            catchError(err => throwError(() => err))
          );
        }
        const headers = request.headers.delete(InterceptorSkipHeader);
        request = request.clone({ headers });
        return next.handle(request);
      })
    );
  }

  private setJwtOrSkip(request: HttpRequest<any>, next: HttpHandler, jwt: string): Observable<HttpEvent<any>> {
    if (request.headers.has(InterceptorSkipHeader)) {
      const headers = request.headers.delete(InterceptorSkipHeader);
      request = request.clone({ headers });
    }

    // ⚠️ Aqui está o ajuste essencial:
    if (request.body instanceof FormData) {
      // Só adiciona o Authorization, NÃO o Content-Type!
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        }
      });
    }

    return next.handle(request);
  }
}
